<template>
  <accordion-simple-item title="Einkaufsbereich" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="teamSearch" type="text" placeholder="Einkaufbereich suchen..." class="p-2 w-full my-2"
               data-ui="search-ekb-input"></TRInput>
      <button @click="navigateTo(`/administration/${accordionIndex}/createTeam`)"
              class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              data-ui="create-new-EKB">
        Neuen Einkaufbereich erstellen
      </button>
      <div class=" overflow-auto " data-ui="ekb-list">
        <div v-for="(purchaser, index) in filteredPurchaser" :key="purchaser.id" :data-ui="'navigate-to'+ purchaser.teamIcon"
             @click="navigateTo(`/administration/${accordionIndex}/team`, { teamId: purchaser.id })"
             class="w-full p-1  flex my-2"
             :class="{ 'bg-trader-blue text-white': teamId == purchaser.id, 'bg-trader-dark-gray': teamId != purchaser.id }">
          <span class="px-2  rounded text-center"
                :style="`background-color: ${purchaser.color}; color: ${getBackgroundColor(purchaser.color)}`">
            {{ purchaser.teamIcon }}
          </span>
          <span class=" pl-4 w-full cursor-pointer"> {{ purchaser.name }} </span>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>


<script>
import TRInput from "@/components/Base/TRInput.vue";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";

export default {
  name: "SPurchaser",
  data() {
    return {
      teamSearch: "",
      purchaser: [],
      colors: [],
      teamId: 0,
    }
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  props: {
    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredPurchaser() {
      return this.purchaser.filter(section =>
          section.teamIcon.toLowerCase().includes(this.teamSearch.toLowerCase()) ||
          section.name.toLowerCase().includes(this.teamSearch.toLowerCase())
      );
    },
  },
  methods: {
    getBackgroundColor(teamColor) {
      // Berechne die Helligkeit der Schriftfarbe
      const color = teamColor.startsWith('#') ? teamColor.substring(1) : teamColor;
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Wähle die Hintergrundfarbe basierend auf der Helligkeit
      return brightness > 125 ? '#000000' : '#FFFFFF';  // Dunkler Hintergrund für helle Schrift und umgekehrt
    },
    async getPurchaser() {
      try {
        // Apollo Client Anfrage
        const {data} = await apolloClient.query({
          query: gql`
          query getPurchasers {
            getPurchasers {
              id
              name
              teamPosition
              teamIcon
              color
            }
          }
        `,
        });

        // Stellen Sie sicher, dass die Daten in shoppingSections gespeichert werden
        this.purchaser = data.getPurchasers;

        // Überprüfen, ob shoppingSections vorhanden und nicht leer ist
        if (this.shoppingSections && this.shoppingSections.length > 0) {
          // Speichern aller Farben in einer Variablen
          this.colors = this.purchaser.map(section => section.color);
        } else {

        }
      } catch (error) {
        console.error("Fehler beim Abrufen der ShoppingSections:", error.message);
      }
    },
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },

  },
  mounted() {
    this.getPurchaser();
    SignalBus.connect(this,"sidebar-update-purchaser", this.getPurchaser);
  },
  beforeUnmount() {
     SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.teamId =  this.$route.params.teamId
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.teamId = params.teamId;
      },
    },
  },
}
</script>